import { Box } from "@mui/material";
import Text from "@/components/Text";
import {
  CURRENT_VISIT_PANEL_MAX_HEIGHT_PX,
  CURRENT_VISIT_PANEL_WIDTH_PX,
  CURRENT_VISIT_PLACEHOLDER,
  CURRENT_VISIT_TEXT_COLOR,
  CURRENT_VISIT_TEXT_FONT_WEIGHT,
  CURRENT_VISIT_TITLE_COLOR,
  CURRENT_VISIT_TITLE_FONT_WEIGHT,
} from "../readmission-f2f-constant";
import { SummaryLine } from "../readmission-f2f-types";
import { formatSummaryLine } from "../readmission-f2f-summary-utils";

export interface CurrentVisitPanelProps {
  lines: SummaryLine[];
}

const CurrentVisitPanel = ({ lines }: CurrentVisitPanelProps) => (
  <Box
    sx={{
      bgcolor: "#1A1A1A0D",
      borderRadius: 1,
      p: 1.5,
      width: CURRENT_VISIT_PANEL_WIDTH_PX,
      maxWidth: "100%",
      maxHeight: CURRENT_VISIT_PANEL_MAX_HEIGHT_PX,
      overflowY: "auto",
      flexShrink: 0,
      overflowWrap: "anywhere",
      alignSelf: "flex-start",
    }}
    display="flex"
    flexDirection="column"
    gap={0.5}
  >
    <Text size={12} fontWeight="bold" c="text.secondary">
      CURRENT VISIT
    </Text>
    {lines.length ? (
      lines.map((line, index) => (
        <Text
          key={`${formatSummaryLine(line)}-${index}`}
          size={13}
          fontWeight={CURRENT_VISIT_TEXT_FONT_WEIGHT}
          c={CURRENT_VISIT_TEXT_COLOR}
          sx={{
            pl: typeof line !== "string" && line.isNested ? 2 : 0,
          }}
        >
          {typeof line === "string" ? (
            line
          ) : (
            <>
              {line.title && (
                <>
                  <Box
                    component="span"
                    fontWeight={CURRENT_VISIT_TITLE_FONT_WEIGHT}
                    color={CURRENT_VISIT_TITLE_COLOR}
                  >
                    {`${line.title}:`}
                  </Box>{" "}
                </>
              )}
              {line.text}
            </>
          )}
        </Text>
      ))
    ) : (
      <Text size={13} c="text.secondary">
        {CURRENT_VISIT_PLACEHOLDER}
      </Text>
    )}
  </Box>
);

export default CurrentVisitPanel;
